import * as React from 'react';

import { useUser } from '../../context/UserContext';

export const AdminOnly: React.FC<any> = ({ children }) => {
  const user = useUser();

  return <React.Fragment>{user && user.isAdmin ? children : null}</React.Fragment>;
};
